import React from 'react'
import FormComponent from "../components/formComponent";

let documentation = {
    title: "Choose Device",
    brief: 'Choose a Device name.',
    content: 'Select an Acuadori device.'
};

class UiGetDevice extends React.Component {

    static defaultProps = {
        error: (error) => { },
        deviceType: null
    };

    constructor(props) {
        super(props);

        this.deviceService = props.services.device;

        this.state = {
            devices: null,
        }
    }
    documentation = () => { return documentation; }

    componentDidMount() {
        this.deviceService.getDevices().then(this.handleGetDevicesNext).catch(this.handleSubmitError);
    }

    handleGetDevicesNext = (response) => {
        //this.setState({ devices: response.data })

        let { deviceType } = this.props;
        let devices = {};
        let serverDevices = response.data;

        for (let i = 0; i < serverDevices.length; i++) {
            let currentDevice = serverDevices[i];
            if (null != deviceType) {
                if (deviceType === currentDevice.type) {
                    devices[currentDevice.name] = currentDevice;
                }
            }
            else {
                devices[currentDevice.name] = currentDevice;
            }
        }
        this.setState({ devices: devices });

    };

    handleSelectDeviceNext = (response) => {
        this.setState({ deviceName: response.device });
        this.props.finished(this.getComponentData(), this.reportAllComponentData());
    };

    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
    };

    renderAlert = (message, variant) => {
        this.setState({ messageAlert: message, variantAlert: variant, showAlert: true });
    };

    renderSelectDevices = () => {
        let { devices } = this.state;
        let formElements = !!devices ? Object.keys(devices).map(name => {
            return { value: name, label: name }
        }) : null;

        let formElement = [{
            key: 'device', type: 'select', inputType: 'select', placeholder: 'Select a device',
            value: '', label: 'Device', options: formElements
        }];

        return (
            <div>
                {!!devices && <FormComponent
                    initialValues={{ name: '', description: '' }}
                    validateFunc={() => { }}
                    submitFunc={this.handleSelectDeviceNext}
                    inputs={formElement}
                />}
            </div>
        );
    };

    getComponentData = () => {
        let { deviceName, devices } = this.state;

        if (!devices) { return null; }
        else if (!devices[deviceName]) { return null; }

        return devices[deviceName];
    }

    reportAllComponentData = () => {
        let { deviceName } = this.state;
        if (!deviceName) {
            return null;
        }

        return { 'DEVICE NAME': deviceName };
    }

    render() {
        //let { deviceName } = this.state;
        return (
            <div className="container-fluid">
                <div className="m-4 p-4">
                    {/* {!deviceName &&*/ this.renderSelectDevices() }
                    {/* {renderReport(this.reportAllComponentData())} */}
                </div>
            </div>);
    }
}


export default UiGetDevice;
export {
    UiGetDevice,
    documentation
}